// data for partners of OKB in Who We Are section
import cnnLogo from "../../Assets/WhoWeAre/Partners/cnn_logo.png";
import elevateLogo from "../../Assets/WhoWeAre/Partners/elevate_prize_foundation_logo.png";
import praxisLogo from "../../Assets/WhoWeAre/Partners/praxis_logo.png";
import globalCitizenLogo from "../../Assets/WhoWeAre/Partners/global_citizen_logo.png";
import gurobiLogo from "../../Assets/WhoWeAre/Partners/gurobi_logo.png";
import dovetailLogo from "../../Assets/WhoWeAre/Partners/dovetail_logo.png";
import mlcLogo from "../../Assets/WhoWeAre/Partners/million_lives_collective_logo.jpg";
import rfLogo from "../../Assets/WhoWeAre/Partners/RF_logo.png";

export const partnersData = [
    {
        id: 1,
        name: "CNN Heroes Program",
        logo: cnnLogo,
        website: "https://www.cnn.com/world/heroes"
    },
    {
        id: 2,
        name: "Elevate Prize Foundation",
        logo: elevateLogo,
        website: "https://elevateprize.org/"
    },  
    {
        id: 3,
        name: "Praxis",
        logo: praxisLogo,
        website: "https://www.praxis.co/"
    },
    {
        id: 4,
        name: "Global Citizen",   
        logo: globalCitizenLogo,
        website: "https://www.globalcitizen.org/en/"
    },
    {
        id: 5,
        name: "Gurobi",
        logo: gurobiLogo,
        website: "https://www.gurobi.com/"
    },
    {
        id: 6,
        name: "Dovetail Impact Foundation",
        logo: dovetailLogo,
        website: "https://dovetailimpact.org/"
    },
    {
        id: 7,
        name: "Million Lives Collective",
        logo: mlcLogo,
        website: "https://millionlives.co"
    },
    {
        id: 8,
        name: "The Rockefeller Foundation",
        logo: rfLogo,
        website: "https://www.rockefellerfoundation.org/"
    }
];

export default partnersData;
